var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_4_2",
    "data-name": "Component 4 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.985,
    height: 20.839,
    viewBox: "0 0 24.985 20.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2738302_filter_settings_sliders_icon",
    "data-name": "2738302_filter_settings_sliders_icon",
    transform: "translate(-1 -2.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M1.781,7.75H8.735a3.151,3.151,0,0,0,6.044,0H25.2a.751.751,0,1,0,0-1.5H14.779a3.151,3.151,0,0,0-6.044,0H1.781a.751.751,0,1,0,0,1.5Zm9.976-2.259A1.51,1.51,0,1,1,10.186,7,1.542,1.542,0,0,1,11.757,5.491Z",
    transform: "translate(0 -1)",
    fill: "#cc0e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M25.2,12.25H23.532a3.151,3.151,0,0,0-6.043,0H1.781a.751.751,0,1,0,0,1.5H17.488a3.151,3.151,0,0,0,6.043,0H25.2a.751.751,0,1,0,0-1.5ZM20.51,14.509A1.51,1.51,0,1,1,22.081,13,1.542,1.542,0,0,1,20.51,14.509Z",
    transform: "translate(0 0.411)",
    fill: "#cc0e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M25.2,18.25H10.076a3.15,3.15,0,0,0-6.043,0H1.781a.751.751,0,1,0,0,1.5H4.033a3.15,3.15,0,0,0,6.043,0H25.2a.751.751,0,1,0,0-1.5ZM7.055,20.509A1.51,1.51,0,1,1,8.625,19,1.542,1.542,0,0,1,7.055,20.509Z",
    transform: "translate(0 1.821)",
    fill: "#cc0e2d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.e323b91ed4f0505918d9b57992e56ef7.svg";
export { ForwardRef as ReactComponent };